export default __webpack_public_path__ + "static/media/Monk's Straps of Sacrifice.274ef354.jpg";